export default __webpack_public_path__ + "static/media/Write.209e0f0a.svg";